import CONSTANTS from '../../util/constants';

const initState = {
    isLoading: false,
    getRuralTrailersData: [],
    getRuralTrailerLogsData: []

}

const RuralTrailersReducer = (state = initState, { type, payload }) => {

    switch (type) {

        case CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT.GET_RURAL_TRAILER_MANAGEMENT_API_SUCCESS:
            return {
                ...state,
                getRuralTrailersData: payload.value
            }



        case CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT.GET_RURAL_TRAILER_LOGS_API_SUCCESS:

            return {
                ...state,
                getRuralTrailerLogsData: payload.value
            }

        default:
            return state
    }
}

export default RuralTrailersReducer;
